export default "__VITE_ASSET__8jxjMt5o__"